import { render } from "./EditArticleButton.vue.js?vue&type=template&id=627d3f28!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditArticleButton.vue?vue&type=template&id=627d3f28"
import script from "./EditArticleButton.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditArticleButton.vue?vue&type=script&lang=js"
export * from "./EditArticleButton.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditArticleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/articles/elements/EditArticleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "627d3f28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('627d3f28', __exports__)) {
    api.reload('627d3f28', __exports__)
  }
  
  module.hot.accept("./EditArticleButton.vue.js?vue&type=template&id=627d3f28!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditArticleButton.vue?vue&type=template&id=627d3f28", () => {
    api.rerender('627d3f28', render)
  })

}


export default __exports__